'use client';
import { useState } from 'react';

import clsx from 'clsx';
import { useAtomValue, useAtom } from 'jotai';

import { Modal } from '@quick/components/Modal';
import type { LoginRes } from '@quick/go-api-types/users/v2/login';

import { LoginComponent } from '@/components/core/Login';

import { loginAtom } from './atoms';

export default function Login() {
  const loginModal = useAtomValue(loginAtom);

  if (!loginModal) return null;
  return <LoginModal />;
}

export function LoginModal() {
  const twoFactor = useState<Omit<LoginRes, 'two_factor'> | null>(null);
  const [twoFactorToken] = twoFactor;
  const [loginModal, setLoginModal] = useAtom(loginAtom);

  return (
    <Modal
      className="absolute left-0 top-0 z-20 dark:bg-gray-500/25"
      isOpen={loginModal}
      events={{ onClose: () => setLoginModal(false) }}
      contentClassName={clsx(
        !twoFactorToken && '!bg-transparent !border-0 !p-0 overflow-y-auto'
      )}
      hideClose
    >
      <div className="h-full max-w-full">
        <LoginComponent
          twoFactor={twoFactor}
          className="self-center"
          onSuccess={() => setTimeout(() => setLoginModal(false), 0)}
        />
      </div>
    </Modal>
  );
}
